<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getTeportTransfersHeaders ()"
    :items="getItems ()"
    :loading="transfersLoading"
    :items-per-page="rowsPerPage"
    :total-items="rowCount"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <td>{{ props.item.reference }}</td>
      <td>{{ props.item.amount | amount }}</td>
      <td>{{ props.item.transferDate | date }}</td>
      <td>{{ props.item.objectType }}</td>
      <td>{{ props.item.objectId }}</td>
      <td>{{ props.item.created | date }}</td>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../../controllers/DataGridSort'
import EnumIterator from '../../helper/EnumIterator';
    export default {
        name: "TransfersDatagrid",
        components: {DataGridSort},
        props: ['transfersLoading','transferReportData','rowsPerPage','rowCount'],
        data () {
            return {
                pagination:
                    {
                        sortBy: 'id'
                    }
            }
        },
        methods: {
            getTeportTransfersHeaders ()
            {
                return [
                    {sortable: true, text: this.$t('krita.reports.transfers.header.reference'), value: 'reference', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.transfers.header.amount'), value: 'amount', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.transfers.header.transferdate'), value: 'transferedDate', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.transfers.header.type'), value: 'objectType', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.transfers.header.id'), value: 'objectId', align: 'left'},
                    {sortable: true, text: this.$t('krita.reports.transfers.header.created'), value: 'created', align: 'left'}
                ]
            },
            getItems ()
            {
              let self = this;

              let items = [];
              for (let transfersReport of self.transferReportData)
              {
                let transfersReportClient = {
                  batchTransferId: transfersReport.batchTransferId,
                  objectId: transfersReport.objectId,
                  objectType: self.$t(EnumIterator.processTransferType(transfersReport.objectType)),
                  reference: transfersReport.reference,
                  transferDate: transfersReport.transferDate,
                  amount: transfersReport.amount,
                  created: transfersReport.created
                };
                items.push(transfersReportClient);
              }
              return items;
            },
            changeSort (sort)
            {
                let self = this;

                self.pagination.sortBy = sort.sortBy;
                self.pagination.descending = sort.descending;
                self.$emit('refreshWithSort',self.pagination);
            }
        }
    }
</script>

<style scoped>

</style>
